<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="couponForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="code">Code</label>
              <input type="text" class="form-control" formControlName="code" id="code" placeholder="Code">
            </div>
            <div class="col-md-6 mb-3">
              <label for="extra-lessons-number">Extra Lessons Number</label>
              <input type="text" class="form-control" formControlName="extraLessonsNumber" id="extra-lessons-number" placeholder="Extra Lessons Number">
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(couponForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
